<template>
  <v-container>
    <h1 class="text-center text-uppercase">products</h1>
    <v-row class="text-center">
      <v-col>
        <v-btn color="primary1" dark @click="newProduct = true">
          <v-icon left>mdi-plus</v-icon>NEW product
        </v-btn>
      </v-col>
      <v-col>
        <v-row>
          <v-col>
            <p class="overline">TOTAL PRODUCTS {{ PRODUCTS.length }}</p>
          </v-col>
          <v-col>
            <v-btn icon @click="getProducts">
              <v-icon>mdi-sync</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Search"
      single-line
      hide-details
    ></v-text-field>
    <br />
    <v-data-table
      :headers="headers"
      :items="PRODUCTS"
      :search="search"
      :items-per-page="10"
      class="elevation-1"
    >
      <template v-slot:item.mrp="{ item }">
        <p>{{item.mrp | rupee}}</p>
      </template>
      <template v-slot:item.pid="{ item }">
        <v-icon color="warning" class="mr-2" @click="editItemPro(item)">mdi-pencil</v-icon>
        <v-icon color="error" @click="deleteItemPro(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
    <v-dialog v-model="newProduct" persistent max-width="600px">
      <v-form ref="newForm">
        <v-card>
          <v-card-title>
            <span class="headline">NEW PRODUCT</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-text-field label="Name" required v-model="p_name" :rules="[RULES.required]"></v-text-field>
              <v-autocomplete
                v-model="p_category"
                :items="CATEGORY"
                item-text="name"
                item-value="id"
                label="Category"
                :rules="[RULES.required]"
              ></v-autocomplete>
              <v-autocomplete
                v-model="p_vendor"
                :items="VENDORS"
                item-text="name"
                item-value="id"
                label="Vendor"
                :rules="[RULES.required]"
              ></v-autocomplete>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col>
                <v-btn color="error" block @click="newProduct = false">Close</v-btn>
              </v-col>
              <v-col>
                <v-btn color="primary1" block dark @click="addProduct">ADD</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="EditProduct" persistent scrollable max-width="50%">
      <v-card>
        <v-form ref="form">
          <v-card-title>
            <span class="headline">EDIT PRODUCT</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-text-field
                label="Name"
                required
                v-model="editProdu.name"
                :rules="[RULES.required]"
              ></v-text-field>
              <!-- <v-text-field
                label="MRP ₹"
                required
                v-model="editProdu.mrp"
                :rules="[RULES.required, RULES.mrp]"
              ></v-text-field>-->
              <v-autocomplete
                v-model="editProdu.cid"
                :rules="[RULES.required]"
                :items="CATEGORY"
                item-text="name"
                item-value="id"
                label="Category"
              ></v-autocomplete>
              <v-autocomplete
                v-model="editProdu.v_id"
                :rules="[RULES.required]"
                :items="VENDORS"
                item-text="name"
                item-value="id"
                label="Vendors"
              ></v-autocomplete>
            </v-container>
          </v-card-text>
        </v-form>
        <v-card-actions>
          <v-row>
            <v-col>
              <v-btn color="error" block @click="EditProduct = false">Close</v-btn>
            </v-col>
            <v-col>
              <v-btn color="primary1" block dark @click="EditProd">UPDATE</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      search: "",
      allCat: [],
      newProduct: false,
      EditProduct: false,
      headers: [
        {
          text: "Product Name",
          align: "start",
          sortable: true,
          value: "name"
        },
        { text: "Category", value: "category" },
        { text: "Vendor", sortable: true, value: "v_name" },
        { text: "Stock", sortable: true, value: "stock" },
        { text: "Actions", value: "pid", width: "10%" }
      ],
      p_name: "",
      p_category: "",
      category_name: "",
      p_vendor: "",
      editProdu: {
        pid: "",
        name: "",
        cname: "",
        v_id: ""
      },
      sortCat: ""
    };
  },
  created() {},
  computed: {
    ...mapGetters(["PRODUCTS", "CATEGORY", "VENDORS", "RULES"])
  },
  methods: {
    ...mapActions([
      "GET_PRODUCTS",
      "NEW_PRODUCT",
      "EDIT_PRODUCTS",
      "DELETE_PRODUCTS"
    ]),
    getProducts() {
      this.$store.commit("SET_LOADING", true);
      this.GET_PRODUCTS().then(() => {
        this.allCat = this.CATEGORY;
        this.$store.commit("SET_LOADING", false);
      });
    },
    addProduct() {
      if (this.$refs.newForm.validate()) {
        this.$store.commit("SET_LOADING", true);
        this.NEW_PRODUCT({
          name: this.p_name,
          id: this.p_category,
          v_id: this.p_vendor
        }).then(() => {
          this.p_category = "";
          this.p_name = "";
          this.p_vendor = "";
          this.$refs.newForm.reset();
          this.$store.commit("SET_LOADING", false);
        });
      }
    },
    editItemPro(item) {
      this.editProdu = {
        pid: item.pid,
        name: item.name,
        cid: item.cid,
        v_id: item.v_id
      };
      this.EditProduct = true;
    },
    EditProd() {
      if (this.$refs.form.validate()) {
        this.EditProduct = false;
        this.$store.commit("SET_LOADING", true);
        this.EDIT_PRODUCTS(this.editProdu).then(() => {
          this.$store.commit("SET_LOADING", false);
        });
      }
    },
    deleteItemPro(item) {
      this.$store.commit("SET_LOADING", true);
      this.DELETE_PRODUCTS({ id: item.pid }).then(() => {
        this.$store.commit("SET_LOADING", false);
      });
    }
  },
  watch: {}
};
</script>

<style></style>
